import React from 'react';
import { Shield, Eye, Users, Cloud } from 'lucide-react';

const GovernanceSection = () => {
  const features = [
    {
      icon: Users,
      title: "RBAC & Workspace Isolation",
      description: "Segregate users, tools, and data by workspace with role-based access controls."
    },
    {
      icon: Eye,
      title: "Traceability & Audit Trails",
      description: "Every action, every query, every workflow logged with full transparency."
    },
    {
      icon: Shield,
      title: "SSO / LDAP Integration",
      description: "Enterprise authentication with single sign-on and LDAP directory services."
    },
    {
      icon: Cloud,
      title: "Cloud Agnostic Deployment",
      description: "Deploy on GCP, AWS, Azure, or On-Premises infrastructure."
    }
  ];

  return (
    <section className="section-spacing bg-[var(--bg-primary)]">
      <div className="light-full-container">
        <div className="light-content-container">
          <div className="space-y-16">
            {/* Header */}
            <div className="text-center space-y-6">
              <h2 className="display-large">Governance & Security</h2>
              <p className="body-large max-w-3xl mx-auto">
                Secure, Auditable, and Enterprise-Ready
              </p>
              <p className="body-medium max-w-4xl mx-auto">
                Govern every data source, tool, and workflow from one control plane.
              </p>
            </div>

            {/* Features Grid */}
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
              {features.map((feature, index) => {
                const IconComponent = feature.icon;
                return (
                  <div 
                    key={index}
                    className="feature-card text-center space-y-6"
                  >
                    <div className="flex justify-center">
                      <div className="icon-container">
                        <IconComponent className="w-8 h-8" />
                      </div>
                    </div>
                    <div className="space-y-3">
                      <h3 className="heading-3">{feature.title}</h3>
                      <p className="body-small">{feature.description}</p>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default GovernanceSection;